import React, {Component, Children} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Helmet from 'react-helmet';
import {push} from 'react-router-redux';
import * as commonActions from './../../actions/commonActions';
import * as tradeBookActions from './../../actions/tradeBookActions';
import * as tradepanelActions from './../../actions/tradepanelActions';
import * as instrumentListActions from './../../actions/instrumentListActions';
import * as activityActions from './../../actions/activityActions';
import * as dashboardActions from './../../actions/dashboardActions';
import * as authActions from '../../redux/modules/auth';
import styles from './TradeBook.less';
import Modal from 'react-modal';
import i18next from 'i18next';
import renderHTML from 'react-render-html';
import { applyStyleapplyToHover,getSeparator,setDirection,unformatLang } from './../../utils/utils';
import {
  ButtonToolbar,
  DropdownButton,
  MenuItem
} from 'react-bootstrap';
import appConstants from './../../appConstants';
import track from 'react-tracking';
import MUIIconWithTooltip from '../../components/IconMaterialUI/MUIIconWithTooltip';

let CmdtyAsk;
let CmdtyBid;
let ValueDate;
let D1;
let T1;
let Header;
let rateDiff;
let variationInAsk;
let variationInBid;
let ordNo = 0;
let rowValues=0;
let index1=0;
let separator;
let decimal;
let decimalCount = 0;
let checkDecimal;
let checkDecimalInput;
let wsData;
// const elementsData = [
//   {"classNames":"header","elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"part1TabContent","elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"part2TabContent","elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"lmtSubmit","elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"lmtClose","elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"rateDiff","elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"closeBtn","elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"mdlWrap","elementType":"normal", "applyTo":"all", "tagNames":"div"},
//   {"classNames":"sellBtn","elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"buyBtn","elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"sellBg","elementType":"normal", "applyTo":"all", "tagNames":"div"},
//   {"classNames":"buyBg","elementType":"normal", "applyTo":"all", "tagNames":"div"},
//   {"classNames":"Pdisabled","elementType":"normal", "applyTo":"all", "tagNames":"div"},
//   {"classNames":"caret","elementType":"normal", "applyTo":"all", "tagNames":"span"},
//   {"classNames":"trdDropdownInput","elementType":"normal", "applyTo":"all", "tagNames":"input"},
//   {"classNames":"dropDownList","elementType":"tag", "applyTo":"all", "tagNames":"li"},
//   {"classNames":"trdDropDown","elementType":"normal", "applyTo":"all", "tagNames":"button"},
//   {"classNames":"dropdown-menu","elementType":"normal", "applyTo":"all", "tagNames":"ul"},
//   {"classNames":"priceDownDiv","elementType":"normal", "applyTo":"all", "tagNames":"div"},
//   {"classNames":"ordConfirmMsg","elementType":"normal", "applyTo":"all", "tagNames":"div"},
// ];
const directionData=[
  {"classNames":"caret","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"header","elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"closeIconMdfyOpnTrd","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"opnTrdMsgTitle","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"dropdown-menu","elementType":"normal", "applyTo":"all", "tagNames":"ul"},
  {"classNames":"cmdtyType","elementType":"normal", "applyTo":"all", "tagNames":"p"},
  {"classNames":"commentDiv","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"rightPart","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"col3","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"opnTrdCmdty","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"opnTrdCmdtyDiv","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"trdDropdownInput","elementType":"normal", "applyTo":"all", "tagNames":"input"},
  {"classNames":"trdbookText","elementType":"normal", "applyTo":"all", "tagNames":"span"}
];
@connect(
state => ({
        userDetail:state.auth.userDetail,
        trdPanelData: state.dashboardRoot.instrumentListReducer.trdPanelData,
        trdingFlag: state.dashboardRoot.tradepanelReducer.trdingFlag,
        status: state.dashboardRoot.instrumentListReducer.status,
        limitOrdBook: state.dashboardRoot.activityReducer.limitOrdBook,
        opnTrdModifyFlag:state.dashboardRoot.tradeBookReducer.opnTrdModifyFlag,
        closeOpnTrdModifypopup:state.dashboardRoot.tradeBookReducer.closeOpnTrdModifypopup,
        socketData: state.dashboardRoot.instrumentListReducer.socketData,
        socketDataStatic:state.dashboardRoot.instrumentListReducer.socketDataStatic,
        check: state.dashboardRoot.instrumentListReducer.check,
        cmdtyArr: state.dashboardRoot.instrumentListReducer.cmdtyArr,
        selectedCssColorTheme:state.dashboardRoot.commonReducer.selectedCssColorTheme,
        opentradeBook:state.dashboardRoot.activityReducer.opentradeBook,
        webSocketFlag:state.dashboardRoot.instrumentListReducer.webSocketFlag,
        stkWiseMarkup:state.dashboardRoot.instrumentListReducer.stkWiseMarkup,
		    selectedCssColor:state.dashboardRoot.commonReducer.selectedCssColor,
        ordcnfrmsg:state.dashboardRoot.activityReducer.ordcnfrmsg,
		    selectedLang:state.dashboardRoot.commonReducer.selectedLang,
        language:state.dashboardRoot.commonReducer.language,
        stkWiseMarkupRandomNo:state.dashboardRoot.instrumentListReducer.stkWiseMarkupRandomNo,
        orderStatus:state.dashboardRoot.tradepanelReducer.orderStatus,
        custInstStkData: state.dashboardRoot.instrumentListReducer.custInstStkData,
          }),{...tradeBookActions,
              ...tradepanelActions,
              ...instrumentListActions,
              ...activityActions,
              ...dashboardActions,
              ...commonActions,
              ...authActions})

@track(() => ({}))

export default class ModifyOpenTradeComponent extends Component
{
  static propTypes =
   {
     closeOpnTrdModifypopup: PropTypes.func,
     opnTrdModifyFlag:PropTypes.bool,
     setOrdersCTID:PropTypes.func,
     handleLimitModal:PropTypes.func,
     opentradeBook:PropTypes.object,
     handleSquareOffOrder: PropTypes.func,
     subscribeTier:PropTypes.func,
     socketData:PropTypes.array,
     ordcnfrmsg:PropTypes.object,
     stkWiseMarkupRandomNo:PropTypes.Number,
     custInstStkData:PropTypes.array
   };
   state = {
    showOpnTrdDialog:false,
    selectedMeasureMkt: '',
    cmdtyIndex:0,
    errorMsg:'',
    CTID:[],
    ordNo:'',
    selectedRmk:"",
    COM:null,
    cmdtyID:"",
    selectedCmdty:"",
    clickedRemove: false,
    selectedActualMktQty:0,
    selectedQuantityMkt:"",
    quantityArrayMkt: [],
    key:1,
    TCO:[],
    T1:'',
    DFMKT:[],
    MEASURE:[],
    isButtonDisabled:false,
    convFactor:[],
    stkWiseAskMarkup:0,
    stkWiseBidMarkup:0,
    showCnfrmMsg:false,
    ordConfirmMsg:'',
    disableSubmit:false,
    orderSocketClosed:false,
    isCustInst:false
  }
   constructor() {
     super();
     this.afterOpenModal = this.afterOpenModal.bind(this);
   }
   componentDidMount(){
    const thisComponent = ReactDOM.findDOMNode(this);
    //const allCssStyleRules = this.props.selectedCssColorTheme;
    //applyStyle(thisComponent, allCssStyleRules, elementsData);
    setDirection(ReactDOM.findDOMNode(this),directionData,this.props.selectedLang);
    const hoverElementsClassNames = [
      {"elmToHover":thisComponent.getElementsByClassName('closeBtn')[0], "classNames":"closeBtn"},
      {"elmToHover":thisComponent.getElementsByClassName("lmtSubmit")[0], "classNames":"lmtSubmit"},
      {"elmToHover":thisComponent.getElementsByClassName("lmtClose")[0], "classNames":"lmtClose"}
    ];
    ////applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    separator = getSeparator(navigator.language,'group');
    decimal = getSeparator(navigator.language,'decimal');
     //this.setState({CTID:this.props.CTID});
     ordNo = this.props.selectLmtRow;
     rowValues= this.props.selectedRow;
     const showPrice = this.props.userDetail.showPrice===undefined||this.props.userDetail.showPrice==="undefined"?"BOTH":this.props.userDetail.showPrice;
     if((rowValues.deal === 'BUY'&&showPrice==='ASK')||(rowValues.deal === 'SELL'&&showPrice==='BID')||
      (rowValues.deal === 'STOP BUY'&&showPrice==='ASK')||(rowValues.deal === 'STOP SELL'&&showPrice==='BID')){
       if(showPrice!=='BOTH'){
         this.setState({disableSubmit:true});
       }
     }
     //this.setState({selectedRmk: rowValues.comments.trim()});
     this.setState({selectedQuantityMkt: rowValues.quantity});
     this.setState({Price: rowValues.price});
     this.setState({selectedCmdtyPairKey:rowValues.iid});
     for(var j=0;j<this.props.socketDataStatic.length;j++){
    	 if(rowValues.iid===this.props.socketDataStatic[j].I){
    		 index1=j;
    		 break;
    	 }
     }
     let CmdtyAskArray;
     let CmdtyBidArray;
     // CmdtyPair = this.props.socketDataStatic[index1].I;
     D1 = this.props.socketDataStatic[index1].D1;
     this.setState({COM:parseInt(this.props.socketDataStatic[index1].B)});
     this.setState({isCustInst:parseInt(this.props.socketDataStatic[index1].C) !== 32 ? false : true});
     this.setState({cmdtyID:this.props.socketDataStatic[index1].I});
     variationInAsk = this.props.socketDataStatic[index1].variationInAsk;
     const dealLimit = this.props.socketDataStatic[index1].dealLimit;
     const validDate = this.props.socketDataStatic[index1].VD;
     ValueDate=this.props.socketDataStatic[index1].VD;
     variationInBid = this.props.socketDataStatic[index1].variationInBid;
     var dec=this.props.socketDataStatic[index1].dec;
     T1=this.props.socketDataStatic[index1].T1;
     this.setState({T1:T1});
     const unit = [];
     var tmpConvFactor=new Map();
     const lengthTrdData = this.props.trdPanelData.length;
     for (let index = 0; index < lengthTrdData; index++) {
       const stk_type = this.props.trdPanelData[index].stk_type;
       if (stk_type === T1) {
         unit.push(this.props.trdPanelData[index].C);
         tmpConvFactor.set(this.props.trdPanelData[index].C,this.props.trdPanelData[index].F)
       }
     }
     /// conversion factor for custom instrument
     if(this.props.custInstStkData !==undefined){
     for (let index = 0; index < this.props.custInstStkData.length; index++) {
       const stk_type = this.props.custInstStkData[index].S;
       if (stk_type === T1) {
         tmpConvFactor.set(this.props.custInstStkData[index].C, this.props.custInstStkData[index].F);
       }
     }
   }
     this.getStkWiseMarkup(rowValues.qtyType,this.props.socketDataStatic[index1].I,this.props.stkWiseMarkup);
     this.setState({convFactor:tmpConvFactor});
     this.setState({MEASURE:unit});
     this.setState({selectedMeasureMkt:rowValues.qtyType});
      for (let index = 0; index < lengthTrdData; index++) {
        const stk_type = this.props.trdPanelData[index].stk_type;
        const type = this.props.trdPanelData[index].C;
        if (T1===stk_type && type===rowValues.qtyType) {
           const DF = this.props.trdPanelData[index].DF;
            const conv_Factor = this.props.trdPanelData[index].F;
           const DFParse=JSON.parse(DF);
           this.setState({DFMKT:DFParse});
           this.setState({convFact:conv_Factor});
         }else if((this.props.socketDataStatic[index1].B === 1 && this.props.socketDataStatic[index1].C === 1)||
         (this.props.socketDataStatic[index1].B === 1 && this.props.socketDataStatic[index1].C === 2) || 
         this.props.socketDataStatic[index1].C === 32){
           const DF=this.props.socketDataStatic[index1].DF;
           const DFParse=JSON.parse(DF);
           this.setState({DFMKT: DFParse});
         }
     }
     let actualQty = unformatLang(rowValues.quantity) ;
     if(parseInt(this.props.socketDataStatic[index1].B) ===1 && parseInt(this.props.socketDataStatic[index1].C) !== 32){
      actualQty=parseFloat(actualQty);
     }else if (parseInt(this.props.socketDataStatic[index1].C) === 32) {
       actualQty=actualQty*parseFloat(tmpConvFactor.get(this.props.socketDataStatic[index1].I));
     } else{
      actualQty=actualQty*parseFloat(tmpConvFactor.get(rowValues.qtyType));
     }
     actualQty=actualQty.toFixed(2);
     this.setState({selectedActualMktQty: actualQty});
     this.props.subscribeTier(rowValues.iid,this.props.webSocketFlag);
   }
   componentWillReceiveProps(nextProps,nextState){
     if(this.props.ordcnfrmsg.CTID !== nextProps.ordcnfrmsg.CTID){
       if(nextProps.ordcnfrmsg.CTID !== undefined){
         if(this.state.CTID.indexOf(nextProps.ordcnfrmsg.CTID)!==-1){
           //this.setState({lmtCnfrmMsgBoxFlag :false});
           this.changebuttonState();
           this.setState({showCnfrmMsg: true});
           this.setState({ordConfirmMsg:nextProps.ordcnfrmsg})
         }
       }
     }
     if(nextProps.stkWiseMarkupRandomNo !== this.props.stkWiseMarkupRandomNo){
       this.getStkWiseMarkup(this.state.selectedMeasureLmt,this.state.cmdtyID,nextProps.stkWiseMarkup);
     }
     if(nextProps.userDetail.showPrice!==this.state.showPrice){
       if(nextProps.userDetail.showPrice!==undefined&&nextProps.userDetail.showPrice!=="undefined"){
         const showPrice = nextProps.userDetail.showPrice===undefined||nextProps.userDetail.showPrice==="undefined"?"BOTH":nextProps.userDetail.showPrice;
         rowValues= this.props.selectedRow;
         if(((rowValues.deal === 'BUY' && showPrice==='ASK')||(rowValues.deal === 'SELL'&&  showPrice==='BID'))||
          ((rowValues.deal === 'STOP BUY'&& showPrice==='ASK')||(rowValues.deal === 'STOP SELL'&& showPrice==='BID'))){
           if(showPrice!=='BOTH'){
             this.setState({disableSubmit:true});
           }else{
             this.setState({disableSubmit:false});
           }
         }else{
           this.setState({disableSubmit:false});
         }
       }
     }
   }
   getStkWiseMarkup = (stk_code,cmdty,stkWiseMarkup) =>{
    try{
     if(stk_code!==undefined && stk_code!==""){
       if(stkWiseMarkup!==null){
         let stkCodeMarkup=stkWiseMarkup.get(cmdty);
         if(stkCodeMarkup !== undefined){
           for(let i=0;i<stkCodeMarkup.length;i++){
             if(stkCodeMarkup[i].SC===stk_code){
               this.setState({stkWiseAskMarkup: stkCodeMarkup[i].ASK,stkWiseBidMarkup: stkCodeMarkup[i].BID});
             }
           }
         }
       }
     }else{
       this.setState({stkWiseAskMarkup: 0,stkWiseBidMarkup: 0});
     }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'getStkWiseMarkup', component:"ModifyOpenTradeComponent"});
    }
   }
   orderSquareOff = (QT,Com, selectedQuantity, selectedMeasure, price, ValueDate,dealType,DocNo,baseRate) =>{
    try{
      if(this.props.orderStatus===2 || this.props.orderStatus===1){
        this.setState({orderSocketClosed: true});
      }else{
        var selectedQuantity = unformatLang(selectedQuantity);
        selectedQuantity=selectedQuantity+"";
        var tempQ= selectedQuantity;
        var check= selectedQuantity.slice(selectedQuantity-1);
        if(check.toUpperCase()==='K')
        {
          tempQ= selectedQuantity.slice(check, -1);
          tempQ=parseInt(tempQ)*1000;
        }
        // if(Com===1){
        //   selectedMeasure="1";
        // }

          if(this.props.userDetail.canTrade===true)
          {
            this.setState({isButtonDisabled: true});
            if (this.props.userDetail.canTrade){
              this.setState({isButtonDisabled: true});
              const user = JSON.parse(localStorage.getItem('user'));
              var CTID =user.location+"_"+user.SID+Math.floor((Math.random() * 1000000) + 1);
              this.state.CTID.push(CTID);
              this.ModifySquareOff(QT,this.state.COM,this.state.cmdtyID, selectedQuantity, selectedMeasure,dealType, price,1,ValueDate,this.state.selectedRmk,CTID,rowValues.docNo,baseRate)
            }
        }
        if(this.props.userDetail.storetradeqty === "0"){
          this.setState({selectedQuantityMkt :""});
          this.setState({selectedActualMktQty :""});
          }

        setTimeout(function() {
          this.setState({isButtonDisabled: false})
        }.bind(this), 5000);
        }
      }catch(e){
        this.props.logFileCreation({error:e.message, originFunction:'orderSquareOff', component:"ModifyOpenTradeComponent"});
      }
    }

    ModifySquareOff = (QT,Com,CmdtyPair, selectedQuantity, selectedMeasure, DealType, Price, OrderType,ValueDate,rmk,CTID,DocNo,baseRate) => {
      try{
        selectedQuantity=selectedQuantity+"";
        var tempQ= selectedQuantity;
        var check= selectedQuantity.slice(selectedQuantity-1);
        var socketDataMap = this.props.socketData.get(CmdtyPair);
        if(check.toUpperCase()==='K')
        {
          tempQ= selectedQuantity.slice(check, -1);
          tempQ=parseInt(tempQ)*1000;
        }
        if(Com===1 && !this.state.isCustInst){
          selectedMeasure="";
        }else if(this.state.isCustInst){
          selectedMeasure="";
        }
            var OMT;
            var PCT;
            const remark=rmk;
            if(OrderType===1)
            {
              OMT=1;
              PCT=1;
            }
            if (tempQ === "" || tempQ <= "0" || parseFloat(tempQ) === 0) {
              this.setState({showOpnTrdDialog:true});
              this.setState({errorMsg:i18next.t('minEnterQty')});          
          } else if(this.props.userDetail.enableCustTradeQtyRO === 1 && tempQ % 1 !== 0) {
            this.setState({showOpnTrdDialog:true});
            this.setState({errorMsg:i18next.t('fractionDigitErrMsg')});
          }
            else if (Number(parseFloat(tempQ)) >Number(parseFloat(unformatLang(rowValues.quantity)))) {
              var error = 'Quantity cannot exceed ' +  rowValues.quantity + ' ' + rowValues.qtyType;
              this.setState({showOpnTrdDialog:true});
              this.setState({errorMsg: error});
            }
            else {
              wsData = this.getWsData(QT,CmdtyPair, tempQ, selectedMeasure, DealType, Price, OrderType, OMT,PCT,remark,ValueDate,CTID,rowValues.docNo,socketDataMap.BI,baseRate);
              this.handleSquareOffOrder(wsData);
              // this.props.closeOpnTrdModifypopup(false);
            }
      }catch(e){
        this.props.logFileCreation({error:e.message, originFunction:'ModifySquareOff', component:"ModifyOpenTradeComponent"});
      }
    }

    @track((props, state) => ({ 
      widgetDetails: { originFunction: "handleSquareOffOrder", event: appConstants.trackingEvents.MODIFY_SQUARE_OFF},
      ordDetails: [wsData]
    }))

    handleSquareOffOrder = (orderData) => {
      try {
        this.props.handleSquareOffOrder(orderData)
      } catch (e) {
        this.props.logFileCreation({error:e.message, originFunction:'handleSquareOffOrder', component:"ModifyOpenTradeComponent"});
      }
    }

    getWsData = (QT, CmdtyId, Quantity, Measure, DealType, price, OrderType, OMT, PCT, Remark, Validty, CTID, docNo, baseInstId, baseRate) => {
      const user = JSON.parse(localStorage.getItem('user'));
      const AccDet = JSON.parse(localStorage.getItem('DFA'));
      if (user === null) {
        dispatch(sessionTimeout());
      }
      const platform = localStorage.getItem('platform');
      let symbol;
      let priceValue = price;
      let quant = Quantity;
      if (!priceValue) {
        priceValue = 0;
      }
      if (quant === '') {
        quant = 0;
      }
    
      var obj = {};
      obj.MT = "NEW_ORDER";
      obj.UID = user.UID;
      obj.UCD = user.trdCode;
      obj.UD = user.UD;
      obj.IID = CmdtyId;
      obj.QT = QT;
      obj.PQ = parseFloat(quant);
      obj.DT = DealType;
      obj.R = parseFloat(priceValue);
      obj.OT = OrderType;
      obj.CID = user.location;
      obj.AC = AccDet.C;
      obj.AD = AccDet.D;
      obj.BSIID = baseInstId;
      obj.BSR = baseRate;
      if (Measure === "") {
        obj.SC = "";
      } else {
        obj.SC = Measure;
      }
      obj.OMT = OMT;
      obj.PCT = PCT;
      obj.UUID = user.authToken;
      obj.RMK = Remark;
      obj.CR = priceValue;
      obj.VD = Validty;
      obj.SID = user.SID;
      obj.CTID = CTID;
      obj.MD = -1;
      obj.LinkDocNo = docNo;
      obj.linkDocNoQty = parseFloat(quant);
      return obj;
    }

    changebuttonState = (event) => {
      try{
        this.setState({isButtonDisabled: false});
      }catch(e){
        this.props.logFileCreation({error:e.message, originFunction:'changebuttonState', component:"ModifyOpenTradeComponent"});
      }
    }

  checkNumberValue =(event) =>{
    try{
       if (String.fromCharCode(event.which) != separator && event.which > 31 && (event.which < 48 || event.which > 57) && (String.fromCharCode(event.which)!==separator) && (String.fromCharCode(event.which)!==decimal) && (event.which !== 107) && (event.which !== 75) && (event.which !== 109) && (event.which !== 77)){
           event.preventDefault();
         }
       if(event.target.value.indexOf(decimal)===-1){
             decimalCount = 0;
       }
       // if(event.which === separator.charCodeAt(0) || (event.which === decimal.charCodeAt(0) && decimalCount>=1)){
       //     event.preventDefault();
       // }
       if(event.which === decimal.charCodeAt(0)){
         decimalCount+=1;
       }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'checkNumberValue', component:"ModifyOpenTradeComponent"});
    }
  }
  quantitySelectionMkt = (event) => {
    try{
      if(event.target.text==="")
      {
        event.target.text="0"
      }
      var check= event.target.text.slice(event.target.text.length-1);
      var tempQ= event.target.text;
      if(check.toUpperCase()==='K')
      {
        tempQ= event.target.text.slice(check, -1);
        tempQ=parseFloat(tempQ)*1000;
      }else if(check.toUpperCase()==='M'){
        tempQ= event.target.text.slice(check, -1);
        tempQ=parseFloat(tempQ)*1000000;
      }
      //convFactor
        this.setState({selectedQuantityMkt: tempQ});
      if(this.state.COM===1 && !this.state.isCustInst){
        tempQ=parseFloat(tempQ);
      }else if (this.state.isCustInst) {
        tempQ=tempQ*parseFloat(this.state.convFactor.get(this.state.cmdtyID));
      } else{
        tempQ=tempQ*parseFloat(this.state.convFactor.get(this.state.selectedMeasureMkt));
      }
      tempQ=tempQ.toFixed(2);
      this.setState({selectedActualMktQty: tempQ});
      if(tempQ<10 && tempQ>0){
        this.props.subscribeTier(this.state.cmdtyID,true);
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'quantitySelectionMkt', component:"ModifyOpenTradeComponent"});
    }
  }
  quantityTypedMKT = (event) => {
    try{
      checkDecimal =getSeparator(navigator.language,'decimal');
      checkDecimalInput  = event.target.value;
      if (checkDecimalInput.indexOf(checkDecimal) !== -1) {
        checkDecimalInput = unformatLang(checkDecimalInput);
      }
      else {
          checkDecimalInput = event.target.value;
      }
      if(event.target.value.charAt(0) === checkDecimal){
        event.target.value="0"+checkDecimal;
        checkDecimalInput="0"+checkDecimalInput;
      }
      var flag=0;
      var c=0;
      for(var i=0;i<event.target.value.length;i++){
        if(event.target.value.charAt(i)=== checkDecimal){
          flag=1;
        }
        if(flag==1){
          c++;
        }
      }
      if(c>4){
        event.target.value= this.state.selectedQuantityMkt;
      }
      if (!(event.target.value.charAt(0).toUpperCase()==='K' || event.target.value.charAt(0).toUpperCase()==='M')) {
      var check= event.target.value.slice(event.target.value.length-1);
      var tempQ= event.target.value;
      if(check.toUpperCase()==='K')
      {
        tempQ= event.target.value.slice(check, -1);
        tempQ=parseFloat(tempQ)*1000;
      }else if(check.toUpperCase()==='M'){
        tempQ= event.target.value.slice(check, -1);
        tempQ=parseFloat(tempQ)*1000000;
      }
        if(!isNaN(tempQ)){
        this.setState({selectedQuantityMkt: (tempQ).toLocaleString(navigator.language,{minimumFractionDigits:3,maximumFractionDigits:3})});
        if(this.state.COM===1 && !this.state.isCustInst){
          if(tempQ!=''){
            tempQ=parseFloat(tempQ);
          }
        }else if (this.state.isCustInst) {
            tempQ=tempQ*parseFloat(this.state.convFactor.get(this.state.cmdtyID));
        }else{
          tempQ=tempQ*parseFloat(this.state.convFactor.get(this.state.selectedMeasureMkt));
        }
        this.setState({selectedActualMktQty: tempQ});
        }else{
          this.setState({selectedActualMktQty: unformatLang(event.target.value)});
          this.setState({selectedQuantityMkt: event.target.value});
      }
    }
      else{
        this.setState({selectedActualMktQty:unformatLang(event.target.value)});
        this.setState({selectedQuantityMkt: event.target.value});
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'quantityTypedMKT', component:"ModifyOpenTradeComponent"});
    }
  }
  onBlurMkt= (event)=> {
    try{
      var tempQ=unformatLang(event.target.value);
      if(tempQ===""){
        tempQ = "";
      }
      if(event.target.value.charAt(0)=== getSeparator(navigator.language,'decimal')){
        event.target.value="0"+event.target.value;
      }
      if (!(event.target.value.charAt(0).toUpperCase()==='K' || event.target.value.charAt(0).toUpperCase()==='M')) {
        var check= event.target.value.slice(event.target.value.length-1);
        tempQ= event.target.value;
        tempQ=unformatLang(tempQ);
          if(check.toUpperCase()==='K')
          {
            tempQ= event.target.value.slice(check, -1);
            tempQ=parseFloat(tempQ)*1000;
          }
          else if(check.toUpperCase()==='M')
          {
            tempQ= event.target.value.slice(check, -1);
            tempQ=parseFloat(tempQ)*1000000;
          }
          if(!isNaN(tempQ) && tempQ !=="" && tempQ !== 0)
          {
            tempQ= event.target.value;
            tempQ=unformatLang(tempQ);
            if(tempQ==="" || tempQ==="NaN" ){
              tempQ ="";
            }
            var tempQuant=Number(parseFloat(tempQ)).toLocaleString(navigator.language, {minimumFractionDigits:3, maximumFractionDigits:3});
            // var tempQuant=Number.isInteger(parseFloat(tempQ))?tempQ:Number(parseFloat(tempQ)).toLocaleString(navigator.language,{minimumFractionDigits:3,maximumFractionDigits:3});
            this.setState({selectedQuantityMkt: tempQuant});
            tempQuant=unformatLang(tempQuant);
            if(this.state.COM===1 && !this.state.isCustInst){
              tempQ=parseFloat(tempQ);
            }else if (this.state.isCustInst) {
                tempQ=tempQ*parseFloat(this.state.convFactor.get(this.state.cmdtyID));
            } else  {
              tempQ=tempQ*parseFloat(this.state.convFactor.get(this.state.selectedMeasureMkt));
            }
            tempQ=tempQ.toFixed(2);
            this.setState({selectedActualMktQty:tempQ});
          // this.setState({selectedActualMktQty: Number.isInteger(parseFloat(tempQ))?tempQ:Number(parseFloat(tempQ)).toLocaleString(navigator.language,{minimumFractionDigits:3,maximumFractionDigits:3})});
          }
          else{
            if(tempQ===""){
              tempQ = "";
            }
            if(tempQ==="NaN"){
              tempQ="";
            }
            if(event.target.value===""){
              tempQ = "";
            }
            this.setState({selectedActualMktQty: tempQ});
            this.setState({selectedQuantityMkt: tempQ});
          }
      }
      else{
          if(tempQ===""){
            tempQ = " ";
          }
          if(!isNaN(tempQ)){
            this.setState({selectedActualMktQty: tempQ});
            //this.setState({selectedActualMktQty: Number.isInteger(parseFloat(tempQ))?tempQ: Number(parseFloat(tempQ)).toLocaleString(navigator.language,{minimumFractionDigits:3,maximumFractionDigits:3})});
            this.setState({selectedQuantityMkt:Number.isInteger(parseFloat(tempQ))?tempQ: Number(parseFloat(tempQ)).toLocaleString(navigator.language,{minimumFractionDigits:3,maximumFractionDigits:3})});
          } else{
              this.setState({selectedActualMktQty: tempQ});
              this.setState({selectedQuantityMkt:tempQ});
          }
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onBlurMkt', component:"ModifyOpenTradeComponent"});
    }
  }
  selectMeasureMkt = (event) => {
    try{
      this.setState({selectedMeasureMkt: event.target.text});
      const lengthTrdData = this.props.trdPanelData.length;
      for (let index = 0; index < lengthTrdData; index++) {
        const stk_type = this.props.trdPanelData[index].stk_type;
        const type = this.props.trdPanelData[index].C;
        if (this.state.T1===stk_type && type===event.target.text) {
            const DF = this.props.trdPanelData[index].DF;
            const conv_Factor = this.props.trdPanelData[index].F;
            const DFParse=JSON.parse(DF);
            this.setState({DFMKT:DFParse});
            this.setState({convFact:conv_Factor});
        }
      }
      this.getStkWiseMarkup(event.target.text,this.state.cmdtyID,this.props.stkWiseMarkup);
      var selectedQty=0;
      if(this.state.selectedQuantityMkt ===""){
        selectedQty=0;
      }
      else{
        selectedQty=this.state.selectedQuantityMkt;
      }
      var tempQ=parseFloat(selectedQty)*parseFloat(this.state.convFactor.get(event.target.text));
      tempQ=tempQ.toFixed(2);
      this.setState({selectedActualMktQty: tempQ});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'selectMeasureMkt', component:"ModifyOpenTradeComponent"});
    }
  }
  closeShowModal = (event) => {
    try{
      this.setState({showOpnTrdDialog: false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeShowModal', component:"ModifyOpenTradeComponent"});
    }
  }
  closePopup = (event) => {
    try{
      this.props.closeOpnTrdModifypopup(false);
      this.props.handleLimitModal(false);
      this.setState({showCnfrmMsg: false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closePopup', component:"ModifyOpenTradeComponent"});
    }
  }

  changePrice = (event) => {
    try{
      this.setState({Price: event.target.value});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'changePrice', component:"ModifyOpenTradeComponent"});
    }
  }
  onBlurRmk = (event) => {
    try{
      const rmk = event.target.value;
      this.setState({selectedRmk: rmk});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onBlurRmk', component:"ModifyOpenTradeComponent"});
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
   if(nextProps.check !== this.props.check){
      if(this.props.cmdtyArr.indexOf(this.state.selectedCmdtyPairKey) !== -1){
           return true;
       }
   }
   if(nextState.selectedActualMktQty !== this.state.selectedActualMktQty){
     return true;
   }
   if(nextState.convFactor !== this.state.convFactor){
      return true;
    }
    if(nextProps.check !== this.props.check){
         return true;
     }
    if(nextState.showOpnTrdDialog !== this.state.showOpnTrdDialog){
      return true;
    }
    if(nextState.errorMsg !== this.state.errorMsg){
      return true;
    }
    if(nextState.time !== this.state.time){
     return true;
    }
    if(nextState.selectedMeasureMkt !== this.state.selectedMeasureMkt){
      return true;
    }
    if(nextState.isButtonDisabled !== this.state.isButtonDisabled){
      return true;
    }
    if(nextState.selectedQuantityMkt !== this.state.selectedQuantityMkt){
      return true;
    }
    if(nextState.DFMKT !== this.state.DFMKT){
      return true;
    }
    if(nextState.OrderType !== this.state.OrderType){
     return true;
    }

    if(nextState.startDatePop !== this.state.startDatePop){
      return true;
    }
    if(nextState.COM !== this.state.COM){
     return true;
    }
    if(nextState.LMTModel !== this.state.LMTModel){
     return true;
    }
    if(nextProps.trdingFlag !== this.props.trdingFlag){
      return true;
    }
    if(nextProps.status !== this.props.status){
      return true;
    }
    if(nextProps.limitOrdBook !== this.props.limitOrdBook){
      return true;
    }
    if(nextProps.opnTrdModifyFlag !== this.props.opnTrdModifyFlag){
       return true;
     }
    if(nextState.Price !== this.state.Price){
      return true;
    }
    if(nextState.selectedRmk !== this.state.selectedRmk){
      return true;
    }
    if(nextProps.ordcnfrmsg !== this.props.ordcnfrmsg){
      return true;
    }
    if(nextState.showCnfrmMsg !== this.state.showCnfrmMsg){
      return true;
    }
    if(nextState.isCustInst !== this.state.isCustInst){
     return true;
    }
  return false;
}
afterOpenModal() {
  try{
    const thisComponent = this.refs.modifyOpntrd;
    //const allCssStyleRules = this.props.selectedCssColorTheme;
    // const elementsData = [
    //   {"classNames":"header", "elementType":"normal", "applyTo":"single", "tagNames":"div"}
    // ];
    // applyStyle(thisComponent, allCssStyleRules, elementsData);
    const directionData = [
      {"classNames":"header", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
      {"classNames":"commonCloseIcon", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
      {"classNames":"commonMsgDir", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
      {"classNames":"trdCloseIcon", "elementType":"normal", "applyTo":"all", "tagNames":"div"}
    ];
    setDirection(thisComponent,directionData,this.props.selectedLang);
    const hoverElementsClassNames = [
        {"elmToHover":thisComponent.getElementsByClassName("closeBtn")[0], "classNames":"closeBtn"}
    ];
    ////applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'afterOpenModal', component:"ModifyOpenTradeComponent"});
  }
}
closeorderSocketClosedModal = (event) => {
  try{
    this.setState({orderSocketClosed:false});
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'closeorderSocketClosedModal', component:"ModifyOpenTradeComponent"});
  }
}
  render() {
    const closeIcon = <MUIIconWithTooltip icon={'Close'} className={`closeBtn commonCloseIcon`} title={i18next.t("close")}/>
    const closeIconImg = <div className={styles.closeIconImg}><img width="16px" src="/images/close.png" /></div>;
    const closeIconofpopup = {  float: 'right'}
    const { selectedActualMktQty,selectedMeasureMkt, selectedQuantityMkt, Price, DealType, Quantity, Validty, valueDate, quantityArrayLmt, DFMKT, MEASURE, OrderType,time,
      COM, lmtOrdersRows,disableSubmit } = this.state;
      let buttonAskFlag=false;
      let buttonBidFlag=false;
      var mktQty;
      let CmdtyAskArray;
      let CmdtyBidArray;
      let CmdtyPair;
      let QTA;
      let QTB;
      let baseAskPrice,baseBidPrice;
      let formatSelectedQty=selectedActualMktQty;
      let CmdtyBidFontPosStart=0;let CmdtyBidFontPosEnd=0;
      let CmdtyAskFontPosStart=0;let CmdtyAskFontPosEnd=0;
      if(rowValues.iid !== undefined){
        var socketDataMap = this.props.socketData.get(rowValues.iid);
        CmdtyPair = socketDataMap.cmdty;
        CmdtyAsk = socketDataMap.ask;
        CmdtyBid = socketDataMap.bid;
        if (CmdtyAsk) {
          CmdtyAsk = (parseFloat(socketDataMap.ask) - this.state.stkWiseAskMarkup).toFixed(socketDataMap.dec);
        }
        if (CmdtyBid) {
          CmdtyBid = (parseFloat(socketDataMap.bid) - this.state.stkWiseBidMarkup).toFixed(socketDataMap.dec);
        }
        let SocketObj=this.props.socketData.get(CmdtyPair);
        QTA=socketDataMap.QTA;
        QTB=socketDataMap.QTB;
        var mf = JSON.parse(socketDataMap.PTN).mf;
        var rf = JSON.parse(socketDataMap.PTN).rf;
        rateDiff=Math.abs(Math.round(((parseFloat(CmdtyBid).toFixed(socketDataMap.dec)-parseFloat(CmdtyAsk).toFixed(socketDataMap.dec)))*mf)).toFixed(rf);
        D1 = socketDataMap.D1;
         Header=socketDataMap.ID;
        variationInAsk = socketDataMap.variationInAsk;
        const dealLimit = socketDataMap.dealLimit;
        const validDate = socketDataMap.VD;
        ValueDate=socketDataMap.VD;
        variationInBid = socketDataMap.variationInBid;
        let dec = socketDataMap.dec;
        if(parseFloat(formatSelectedQty)===0 || formatSelectedQty===""){
          buttonAskFlag=false;
          buttonBidFlag=false;
        }
          if(formatSelectedQty === ""){
            mktQty = 0;
          }else{
            mktQty = formatSelectedQty;
          }
          if(isNaN(mktQty)){
            buttonAskFlag=true;
            buttonBidFlag=true;
          }
          if(parseFloat(mktQty) >0){
              if(socketDataMap.Tr_A)
              {
               if(socketDataMap.Tr_A.length>0){
                   for(var ti=0;ti<socketDataMap.Tr_A.length;ti++)
                   {
                        if(parseFloat(socketDataMap.Tr_A[ti].Q)>= parseFloat(formatSelectedQty))
                        {
                          CmdtyAsk=(socketDataMap.Tr_A[ti].M-this.state.stkWiseAskMarkup).toFixed(socketDataMap.dec);
                          QTA=socketDataMap.Tr_A[ti].QT;
                          baseAskPrice=socketDataMap.Tr_A[ti].BM;
                          buttonAskFlag=false;
                          break;
                        }
                        else {
                            buttonAskFlag=true;
                        }
                      };
            	}
              else if(parseFloat(formatSelectedQty)!==0){
                 buttonAskFlag=true;
              }
            }
            if(socketDataMap.Tr_B)
            {
              if(socketDataMap.Tr_B.length>0){
                  for(var ti=0;ti<socketDataMap.Tr_B.length;ti++)
                  {
                      if(parseFloat(socketDataMap.Tr_B[ti].Q)>=parseFloat(formatSelectedQty))
                      {
                        CmdtyBid=(socketDataMap.Tr_B[ti].M-this.state.stkWiseBidMarkup).toFixed(socketDataMap.dec);
                        QTB=socketDataMap.Tr_B[ti].QT;
                        baseBidPrice=socketDataMap.Tr_B[ti].BM;
                        buttonBidFlag=false;
                        break;
                      }
                      else {
                          buttonBidFlag=true;
                      }
                  };
            	}
              else if(parseFloat(formatSelectedQty)!==0){
                      buttonBidFlag=true;
              }
            }
          }
          if (CmdtyBid) {
            CmdtyBidArray = Number(CmdtyBid).toLocaleString(navigator.language,{ minimumFractionDigits: dec }).split('');
            CmdtyBidFontPosStart = CmdtyBidArray.length - JSON.parse(socketDataMap.PTN).bs;
            CmdtyBidFontPosEnd = (CmdtyBidArray.length - JSON.parse(socketDataMap.PTN).se) - 1;
          }
          if (CmdtyAsk) {
            CmdtyAskArray = Number(CmdtyAsk).toLocaleString(navigator.language,{ minimumFractionDigits: dec }).split('');
            CmdtyAskFontPosStart = CmdtyAskArray.length - JSON.parse(socketDataMap.PTN).bs;
            CmdtyAskFontPosEnd = (CmdtyAskArray.length - JSON.parse(socketDataMap.PTN).se) - 1;
          }
        }
        if(!parseFloat(CmdtyBid)){ buttonBidFlag = true }
        if(!parseFloat(CmdtyAsk)){ buttonAskFlag = true }
      return (
        <div id="OpnTrdDiv" className={`${this.props.selectedCssColor}`}>
           <div className={`${styles.header} header`}>
              <p className={`${styles.msgTitle} opnTrdMsgTitle`}><span className="trdbookText">{i18next.t(Header)}</span>: <span>{i18next.t(ordNo)}</span></p>
              <span onClick={this.closePopup} className="closeIcon closeIconMdfyOpnTrd">{closeIcon}</span>
            </div>
          <Modal isOpen={this.state.showOpnTrdDialog} className={styles.warningModal} id="editOpnTrdWarning" onAfterOpen={this.afterOpenModal}>
            <div ref="modifyOpntrd" className="OpntrdModifyWrap" >
              <div className={`${styles.header} header`}>
                <span className={`${styles.msgTitle}`}>{i18next.t("error")}</span>
                <span onClick={this.closeShowModal} className={`${styles.moifycloseIcon} closeIcon`} id="modifyOpnTrdClose">
                {closeIcon}
                </span>
              </div>
              <div className={`${styles.msg} commonMsgDir`}>
                {this.state.errorMsg && this.state.errorMsg != "" ? <p>{renderHTML(this.state.errorMsg)}</p> : null}
              </div>
            </div>
          </Modal>
          <Modal isOpen={this.state.orderSocketClosed} id="opnTrdErrModal" className={styles.warningModal} onAfterOpen={this.afterOpenModal}>
            <div ref="errorMSG" className="mdlWrap" >
              <div className={`${styles.header} header`}>
                <span className={`${styles.msgTitle}`}>{i18next.t("error")}</span>
              </div>
              <span onClick={this.closeorderSocketClosedModal} className={`${styles.moifycloseIcon} closeIcon`} id="modifyOpnTrdClose">
                {closeIcon}
              </span>
              <div className={`${styles.msg} msg commonMsgDir`}>
                <p>{i18next.t("orderStatus")}</p>
            </div>
          </div>
          </Modal>
          <div className={`${styles.OpnTrdWrap}`}>
          <div className={parseInt(this.props.status) !== 0 ? `${styles.part1TabContent} part1TabContent ${styles.disabled}` : `${styles.part1TabContent} part1TabContent`}>
          {rowValues.deal==="BUY" ?
          <div className={this.state.isButtonDisabled === true||parseInt(this.props.status) !== 0|| buttonBidFlag===true || disableSubmit===true ? variationInBid === 'increment' ? `${styles.increment} ${styles.Opntrdsell} ${styles.disabled} text-center` : `${styles.decrement} ${styles.Opntrdsell} ${styles.disabled} text-center` : variationInBid === 'increment' ? `${styles.increment} ${styles.Opntrdsell} text-center` : `${styles.decrement} ${styles.Opntrdsell} text-center`}
            onClick={() => this.orderSquareOff(QTB,this.state.COM, selectedQuantityMkt, selectedMeasureMkt, CmdtyBid, ValueDate,0,rowValues.docNo,baseBidPrice)} id="trdMktDiv">
              <div className={`${styles.OpntrdbuyRate} buyBg`} data-for={this.props.keyValue+"_bid"} data-delay-show='10' data-tip={this.state.rateConvRoundOFFBid +" "+selectedMeasureMkt}>
                  {buttonBidFlag === false && parseInt(this.props.status) === 0 && CmdtyBidArray && parseFloat(CmdtyBid) ?
                    <div>
                        {variationInBid ?
                          <div className={styles.arrowPriceUp}><span className={variationInBid === 'increment' ? `upArrow` : `downArrow`}/></div>
                          : null}
                        <p>
                          {CmdtyBidArray && CmdtyBidArray.map((item, index) => {
                            return (
                              <span className={(index >= CmdtyBidFontPosStart && index <= CmdtyBidFontPosEnd
                                ? `${styles.largefont}`
                                : null)}>{item}</span>
                            );
                          })
                        }
                        </p>
                      </div>
                    : (buttonBidFlag === true && parseInt(this.props.status) === 0 ?
                  <div className={`${styles.sqrOffPriceDown} priceDownDiv`}> - - - -</div> : <div className="sk-fading-circle">
                      <div className="sk-circle1 sk-circle"></div><div className="sk-circle2 sk-circle"></div><div className="sk-circle3 sk-circle"></div>
                      <div className="sk-circle4 sk-circle"></div><div className="sk-circle5 sk-circle"></div><div className="sk-circle6 sk-circle"></div>
                      <div className="sk-circle7 sk-circle"></div><div className="sk-circle8 sk-circle"></div><div className="sk-circle9 sk-circle"></div>
                      <div className="sk-circle10 sk-circle"></div><div className="sk-circle11 sk-circle"></div><div className="sk-circle12 sk-circle"></div>
                    </div> )}
                    <div className={`${styles.sellBtn} sellBtn`} id="mktSellbtn">{i18next.t('SELL')} {D1}</div>
                </div>
              </div>
            :
            <div className={this.state.isButtonDisabled === true|| parseInt(this.props.status) !== 0 || buttonAskFlag===true || disableSubmit===true ? variationInAsk === 'increment' ? `${styles.increment} ${styles.Opntrdbuy} ${styles.disabled} text-center` : `${styles.decrement} ${styles.Opntrdbuy} ${styles.disabled} text-center` : variationInAsk === 'increment' ? `${styles.increment} ${styles.Opntrdbuy} text-center` : `${styles.decrement} ${styles.Opntrdbuy} text-center`}
              onClick={() => this.orderSquareOff(QTA,this.state.COM, selectedQuantityMkt, selectedMeasureMkt, CmdtyAsk, ValueDate,1,rowValues.docNo,baseAskPrice)} id="trdMktDiv">
                <div className={`${styles.OpntrdsellRate} sellBg`}>
                  {buttonAskFlag === false && parseInt(this.props.status) === 0 && CmdtyAskArray && parseFloat(CmdtyAsk) ?
                     <div>
                     {variationInAsk ?
                       <div className={styles.arrowPriceDown}><span className={variationInAsk === 'increment' ? `upArrow` : `downArrow`}/></div>
                       : null}
                        <p>
                          {CmdtyAskArray && CmdtyAskArray.map((item, index) => {
                            return (
                              <span className={(index >= CmdtyAskFontPosStart && index <= CmdtyAskFontPosEnd
                                ? `${styles.largefont}`
                                : null)}>{item}</span>
                            );
                          })
                        }
                        </p>
                      </div>
                    : (buttonAskFlag === true && parseInt(this.props.status) === 0 ?
                  <div className={`${styles.sqrOffPriceDown} priceDownDiv`}> - - - -</div> : <div className="sk-fading-circle">
                      <div className="sk-circle1 sk-circle"></div><div className="sk-circle2 sk-circle"></div><div className="sk-circle3 sk-circle"></div>
                      <div className="sk-circle4 sk-circle"></div><div className="sk-circle5 sk-circle"></div><div className="sk-circle6 sk-circle"></div>
                      <div className="sk-circle7 sk-circle"></div><div className="sk-circle8 sk-circle"></div><div className="sk-circle9 sk-circle"></div>
                      <div className="sk-circle10 sk-circle"></div><div className="sk-circle11 sk-circle"></div><div className="sk-circle12 sk-circle"></div>
                    </div> )}
                    <div className={`${styles.buyBtn} buyBtn`} id="mktBuybtn">{i18next.t('BUY')} {D1}</div>
                </div>
              </div>
            }
            </div>
            {this.state.ordConfirmMsg.remark1 !== undefined && this.state.showCnfrmMsg === true ?
              <div className={`${styles.ordConfirmMsg} ordConfirmMsg`} ><div>
              {i18next.t(this.state.ordConfirmMsg.remark1)}<br /><p>{i18next.t(this.state.ordConfirmMsg.remark2)}</p></div></div>
            : null}
            <div className={`${styles.part2TabContent} part2TabContent`}>
              <div className={`${styles.rightPart}  rightPart ${this.props.language}`}>
                  <div className={`${styles.col3} opnTrdCmdty`}>
                      <p className={`${styles.Pdisabled} Pdisabled opnTrdCmdtyDiv`} >{D1}</p>
                  </div>
                  <div className={ this.state.COM===2 && !this.state.isCustInst ? `${styles.qtyselection} ` : `${styles.col8}  eurQty`} id="LMTQtyMenu" style={this.props.selectedLang.col5}>
                      <ButtonToolbar>
                        <DropdownButton id="dropdown-size-medium" className="trdDropDown qtyDropDown">
                           {DFMKT.map((qntity) => {
                            return (
                              <MenuItem onClick={this.quantitySelectionMkt} id="lmtQtySelectionLmt" className="dropDownList" >{qntity}</MenuItem>
                            );
                          })
                        }
                        </DropdownButton>
                      </ButtonToolbar>
                      <input type="text" className={`${styles.dropdownInput} trdDropdownInput`}  id="lmtQuantity" value={selectedQuantityMkt}   onBlur={this.onBlurMkt} onChange={this.quantityTypedMKT} onKeyPress={this.checkNumberValue} placeholder={i18next.t("quantity")}/>
                    </div>
                  { this.state.COM===2  && !this.state.isCustInst ?
                  <div className={`${styles.opnTrdDropDown}  LMTdropMenu opnTrdUnitMeasure`} id="lmtMeasure" >
                    <ButtonToolbar>
                      <DropdownButton title={selectedMeasureMkt} id="dropdown-size-medium" className={`${styles.Pdisabled} Pdisabled`}  disabled>
                        {MEASURE && MEASURE.map((unitMeasure) => {
                          return (
                            <MenuItem onClick={this.selectMeasureMkt} id="lmtSelectMeasureLmt">{unitMeasure}</MenuItem>
                          );
                        })
                      }
                      </DropdownButton>
                    </ButtonToolbar>
                  </div>
                  : null}
                </div>
            <div className={`${styles.comments_wrap_overlay} commentDiv`} >
              <div className={`${styles.comments}`}>
              <textarea ref="comments" rows="1" value={this.state.selectedRmk} placeholder={i18next.t("comments")} onChange={this.onBlurRmk} className={`${styles.commentsLmt} form-control`}  id="lmtCommentText"></textarea>
              </div>
            </div>
          </div>
          </div>
        </div>
    );
  }
}
